import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../hooks/useAuth';
import { createLogger } from '../utils/logger';

const log = createLogger('LoginPage');

export const LoginPage: React.FC = () => {
  const { login } = useAuth();

  const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-slate-50 p-4 overflow-hidden">
      {/* Soft gradient background accents */}
      <div className="pointer-events-none absolute -top-32 -left-32 w-96 h-96 rounded-full bg-indigo-200/40 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-purple-200/40 blur-3xl" />

      <div className="relative bg-white p-8 rounded-2xl border border-slate-200 shadow-soft max-w-md w-full text-center">
        <div className="flex flex-col items-center mb-6">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center shadow-md mb-4">
            <img src="/logo.png" alt="360 Lightning" className="w-9 h-9 object-contain" />
          </div>
          <h1 className="text-2xl font-semibold text-slate-900 tracking-tight">360 Lightning</h1>
        </div>

        {!clientId && (
          <div className="mb-6 p-4 bg-red-50 text-red-600 rounded-lg text-sm text-left">
            <p className="font-semibold mb-1">Configuration Error</p>
            <p>VITE_GOOGLE_CLIENT_ID is missing.</p>
            <p className="mt-2 text-xs text-slate-500">Please check your environment variables or .env file.</p>
          </div>
        )}

        <p className="text-slate-600 mb-8 text-sm">
          Sign in with your Google account to access the monitor and generate scans.
        </p>

        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              if (credentialResponse.credential) {
                log.info('Google login successful');
                login(credentialResponse.credential);
              }
            }}
            onError={() => {
              log.error('Google login failed');
            }}
            useOneTap
          />
        </div>
      </div>
    </div>
  );
};
